var _classCallCheck = require("C:\\Users\\evelia.santos\\eclipse-JDK11\\front_cuestionarios\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\evelia.santos\\eclipse-JDK11\\front_cuestionarios\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

module.exports =
/*#__PURE__*/
function () {
  "use strict";

  function Query(data) {
    _classCallCheck(this, Query);

    this.data = data.map(function (item) {
      item.sortScore = 0;
      return item;
    });
  }

  _createClass(Query, [{
    key: "filter",
    value: function filter(func) {
      this.data = this.data.filter(func);
      return this;
    }
  }, {
    key: "filterBy",
    value: function filterBy(key, func) {
      this.data = this.data.filter(function (item) {
        return func(item[key]);
      });
      return this;
    }
  }, {
    key: "search",
    value: function search(key, term) {
      var score = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      switch (typeof term) {
        case 'boolean':
          this.data = this.data.filter(function (item) {
            return item[key] === term;
          });
          break;

        case 'string':
          this.data = this.data.filter(function (item) {
            var regFind = new RegExp(term, 'gi');
            var termMatches = (item[key].match(regFind) || []).length;
            item.sortScore += termMatches;
            return termMatches;
          });
          break;
      }

      return this;
    }
  }, {
    key: "sort",
    value: function sort() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'sortScore';
      this.data = this.data.sort(function (a, b) {
        if (a[key] < b[key]) return -1;
        if (a[key] > b[key]) return 1;
        return 0;
      });
      return this;
    }
  }, {
    key: "paginate",
    value: function paginate() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      var min = page * perPage - perPage;
      var max = min + perPage;
      this.data = this.data.slice(min, max);
      return this;
    }
  }, {
    key: "results",
    get: function get() {
      return this.data;
    }
  }]);

  return Query;
}();